import {
  Injectable,
  ComponentRef,
  ViewContainerRef,
  EmbeddedViewRef
} from '@angular/core';
import { PlessAlertComponent, PlessAlert } from './pless-alert/pless-alert.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';

/**
 * ダイアログ表示を提供するサービス
 */
@Injectable()
export class PlessDialogService {

  /** z-indexの最低値. */
  public static MIN_Z_INDEX = 5;

  constructor(
    private modalService: NgbModal
  ) { }

  /**
   * 指定コンポーネントをモーダルで表示
   *
   * @param component 表示するコンポーネント
   * @param options モーダル表示時のオプション指定
   */
  openModal(component: any, options?: NgbModalOptions): NgbModalRef {
    if (options == null) {
      // backdrop: 'static' ⇒ Window外のクリックで閉じない
      // keyboard: false ⇒ ESC押下で閉じない
      options = { backdrop: 'static', keyboard: false };
    }
    return this.modalService.open(component, options);
  }

  /**
   * 指定コンポーネントをモードレスで表示
   *
   * @param component 表示するコンポーネント
   * @param viewContainerRef コンポーネントを追加するコンテナ
   * @param appendBody bodyに追加
   */
  openModeless(component: any, viewContainerRef: ViewContainerRef, appendBody: boolean = false): ComponentRef<{}> {
    const compRef = viewContainerRef.createComponent(component);
    if (appendBody) {
      // ※モーダル表示した子画面からbodyに追加すると背面に追加されます
      const elemnt = (compRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
      document.body.appendChild(elemnt);
    }
    return compRef;
  }

  /**
   * アラートを表示
   *
   * @param text 表示する文字列(改行は\nで指定)
   * @param title アラートのタイトル
   * @param buttons 表示するボタン
   * @param closeHander 閉じる時に実行する処理
   */
  openAlert(text: string, title?: string, buttons?: Array<PlessAlert>, closeHander?: Function) {
    const ref = this.openModal(PlessAlertComponent);
    const instance = ref.componentInstance as PlessAlertComponent;
    instance.setData(text, title, buttons);
    instance.closeHander = closeHander;
    instance.closeFunction = () => {
      ref.close();
    };
  }

}
